// @ts-nocheck
import { EagerLoadingLogoProvider } from "@insite/client-framework/Common/EagerLoadingLogo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import dismissRfqUpdates from "@insite/client-framework/Store/Context/Handlers/DismissRfqUpdates";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import SkipNav, { SkipNavStyles } from "@insite/content-library/Components/SkipNav";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link from "@insite/mobius/Link";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import Typography from "@insite/mobius/Typography";
// import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries"; // Foundation
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import React, { useEffect } from "react"; // Foundation
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Store Custom Code */
import { headerHideForMobileStyles } from "@store/Themes/common/mixins/header";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code */

// Foundation --->
// import constants from "@store/constants"; // Store Custom Code
import zoneElementsSelector from "@store/Framework/Common/Utilities/zoneElementsSelector";
// import useHeaderHeight from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useHeaderHeight"; // Store Custom Code
// import useIsHeaderFixed from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useIsHeaderFixed"; // Store Custom Code
import { useIsAuthenticated } from "@store/Framework/Store/Foundation/Context/ContextHooks";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import loadCurrentAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadCurrentAccount";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden from "@insite/mobius/Hidden";
import { HiddenProps } from "@insite/mobius/Hidden/Hidden";
import { getProp } from "@insite/mobius/utilities";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import useIsomorphicLayoutEffect from "@toolkit/Framework/Common/Hooks/useIsomorphicLayoutEffect";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import React, { useEffect, useLayoutEffect, useRef } from "react";

// Sas --->
import constants from "@store/constants";
import useHeaderHeight from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useHeaderHeight";
import useHeaderOpacity from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useHeaderOpacity";
import useIsHeaderFixed from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useIsHeaderFixed";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
// <--- Sas

const enum fields {
    isHeaderFixedOption = "isHeaderFixedOption",
    // Sas
    isFullWidth = "isFullWidth",
    backgroundColor = "backgroundColor",
    isTransparantAtTop = "isTransparantAtTop",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.isHeaderFixedOption]: boolean;
        // Sas
        [fields.isFullWidth]: boolean;
        [fields.backgroundColor]: "primary" | "secondary" | "tertiary";
        [fields.isTransparantAtTop]: boolean;
    };
}
// <--- Foundation

const mapStateToProps = (state: ApplicationState) => ({
    siteName: state.context.website.name,
    session: getSession(state),
    myAccountPageUrl: getPageLinkByPageType(state, "MyAccountPage")?.url,
});

const mapDispatchToProps = {
    dismissRfqUpdates,
    // Foundation
    loadCurrentAccount,
};

type Props = PageProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext &
    HasHistory &
    // Foundation
    OwnProps;

export interface HeaderStyles {
    page?: MobiusPageProps;
    container?: InjectableCss;
    skipToContent?: SkipNavStyles;
    websiteName?: InjectableCss;
    // Store Custom Code
    wrapper?: InjectableCss;
    contentWrapper?: InjectableCss;
    navWrapper?: InjectableCss;
    bottomContentWrapper?: InjectableCss;
    printWrapper?: InjectableCss;
    // Foundation
    logoWrapper?: InjectableCss;
    navigationWrapper?: InjectableCss;
    secondaryNavigationWrapper?: InjectableCss;
    searchNavigationWrapper?: InjectableCss;
    loginCart?: InjectableCss;
    mainNavigation?: HiddenProps;
    search?: InjectableCss;
}

// Foundation --->
const secondaryNavigationWrapperSpacing = 8;
const searchNavigationWrapperSpacing = 24;

const navigationsContainer = {
    css: css`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        ${siteWidthStyles()}
        background-color: ${getColor("common.background")};
    `,
};
// <--- Foundation

export const headerStyles: HeaderStyles = {
    skipToContent: {
        skipToContent: {
            variant: "primary",
            css: css`
                margin: 0;
                position: absolute;
                clip: rect(0, 0, 0, 0);
                &:focus {
                    clip: unset;
                    z-index: 1000;
                }
            `,
        },
    },
    page: {
        fullWidth: [true, true, true, true, true], // Foundation
        css: css`
            /* Sas ---> */
            padding: ${pxToRem(10, 0)};
            transition: all 0.3s ease-in-out;
            /* <--- Sas */
        `,
    },
    container: {
        /* Sas ---> */
        css: css`
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            transition: all 0.3s ease-in-out;
        `,
        /* <--- Sas */
    },
    websiteName: {
        css: css`
            @media print {
                display: block;
            }
            font-size: ${pxToRem(12)};
            padding-left: ${pxToRem(15)};
            display: none;
        `,
    },
    // Sas Removed Code
};

const styles = headerStyles;

const Header = ({
    id,
    siteName,
    session,
    toaster,
    history,
    myAccountPageUrl,
    dismissRfqUpdates,
    // Foundation
    loadCurrentAccount,
    fields: { isHeaderFixedOption, isFullWidth, backgroundColor, isTransparantAtTop }, // Sas
}: Props) => {
    // Foundation --->
    const { isFullOpacity } = useHeaderOpacity(!isTransparantAtTop); // Sas
    const mainRef = useRef<HTMLDivElement>(null);
    const secondaryRef = useRef<HTMLDivElement>(null);
    const { isHeaderFixed, setIsHeaderFixed } = useIsHeaderFixed();
    const { setHeaderHeight } = useHeaderHeight();
    const isomorphicLayoutEffect = useIsomorphicLayoutEffect;
    // <--- Foundation

    const viewMyDashboardClickHandler = () => {
        if (myAccountPageUrl) {
            history.push(myAccountPageUrl);
        }
    };

    // Foundation --->
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
        if (mainRef.current) {
            const mainContainerHeight =
                mainRef.current?.getBoundingClientRect().height || constants.defaultHeaderHeight.mainHeight;
            const secondaryContainerHeight =
                secondaryRef.current?.getBoundingClientRect().height || constants.defaultHeaderHeight.secondaryHeight;

            setHeaderHeight({
                mainHeight: mainContainerHeight,
                secondaryHeight: secondaryContainerHeight,
            });
        }
    }, [mainRef.current?.getBoundingClientRect().height, secondaryRef.current?.getBoundingClientRect().height]); // Sas

    isomorphicLayoutEffect(() => {
        setIsHeaderFixed(isHeaderFixedOption);
    }, [isHeaderFixedOption]);

    useEffect(() => {
        if (isAuthenticated) {
            loadCurrentAccount();
        }
    }, [isAuthenticated]);
    // <--- Foundation

    useEffect(() => {
        if (session.hasRfqUpdates && myAccountPageUrl) {
            toaster.addToast({
                body: (
                    <>
                        <Typography>{translate("You have new quote information.")}</Typography>
                        <Link onClick={viewMyDashboardClickHandler}>{translate("View My Dashboard")}</Link>
                    </>
                ),
                messageType: "info",
                timeoutLength: 1000 * 60 * 60 * 24 * 365,
                onClose: () => {
                    dismissRfqUpdates();
                },
            });
        }
    }, [myAccountPageUrl]);

    // Foundation --->
    const pageStyles: MobiusPageProps = {
        ...styles.page,
        css: css`
            ${styles?.page?.css}
            /* Sas ---> */
            background: ${isFullOpacity
                ? getColor(backgroundColor)
                : "linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0))"};

            ${isHeaderFixed &&
            css`
                overflow: visible !important; /* Required to override overflow from Mobius Page Component */
                position: fixed !important;
                top: 0;
                width: 100%;
                z-index: ${getProp("theme.zIndex.stickyHeader")};
            `}
            /* <--- Sas */

            &:hover,
            :focus,
            :active {
                background-color: ${getColor(backgroundColor)}; /* Sas */
            }
        `,
    };

    const containerStyles: InjectableCss = {
        // Sas --->
        css: css`
            ${styles.container?.css}

            ${!isFullWidth
                ? css`
                      ${siteWidthStyles()}
                  `
                : css`
                      ${x => breakpointValues(x.theme.design.layout.spacing.side, ["padding-right", "padding-left"])}
                  `}

                      opacity: ${isFullOpacity ? "1" : "0.7"};

            &:hover,
            :focus,
            :active {
                opacity: 1;
            }
        `,
        // <--- Sas
    };
    // <-- Foundation

    const afterHeader = React.createRef<HTMLSpanElement>();
    return (
        <>
            {siteName && <Typography {...styles.websiteName}>{siteName}</Typography>}
            <Page as="header" isHeader={true} {...pageStyles}>
                <SkipNav
                    extendedStyles={styles.skipToContent}
                    text={translate("Skip to main content")}
                    destination={afterHeader}
                />
                {/* Sas ---> */}
                <StyledWrapper {...containerStyles} id="headerContainer">
                    <Zone contentId={id} zoneName="MainNavigation" />
                </StyledWrapper>
                {/* <--- Sas */}
                {/* <Zone contentId={id} zoneName="Breadcrumb" /> -- Hide breadcrumb until it's being started */}
                <span ref={afterHeader} tabIndex={-1} />
            </Page>
        </>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withToaster(withHistory(Header))),
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
        // Foundation -->
        fieldDefinitions: [
            // Sas --->
            {
                name: fields.backgroundColor,
                displayName: "Background color",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "Primary",
                        value: "primary",
                    },
                    {
                        displayName: "Secondary",
                        value: "secondary",
                    },
                    {
                        displayName: "Tertiary",
                        value: "tertiary",
                    },
                ],
                tooltip: "Base on styleGuide",
                defaultValue: "secondary",
                fieldType: "General",
            },
            {
                name: fields.isFullWidth,
                displayName: "Full Width",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.isTransparantAtTop,
                displayName: "Background is transparent at top",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                isVisible: item => item.fields.isHeaderFixedOption,
            },
            // <--- Sas
            {
                name: fields.isHeaderFixedOption,
                displayName: "Make Header Fixed When Scrolling",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
        // <-- Foundation
    },
};

export const HeaderContext = "HeaderContext";

export default pageModule;
